// This file is auto-generated by scripts/generate-version.js — do not edit manually
export const APP_VERSION = 'v1.5.1';
